import { markCourtMatchStarted } from '../matchTimerUtils';

const EMPTY_GAME_CREATION = {
  origin: 'matchmaking',
  algorithm: 'two_stage_local',
  isAltered: false,
  scheduledGameId: null,
};

function rosterIds(list) {
  return (list || []).filter(Boolean);
}

function isFullRoster(team1, team2) {
  return team1.length > 0 && team1.length === team2.length;
}

/**
 * Apply a local matchmaking fill to active or upcoming courts and drop those players from the waitlist.
 */
export function applyLocalCourtFill(state, fill, { courtType, index }) {
  const team1 = rosterIds(fill?.team1);
  const team2 = rosterIds(fill?.team2);
  const seated = new Set([...team1, ...team2]);
  const originMeta = fill?.type === 'scheduled'
    ? {
        origin: 'scheduled',
        algorithm: fill.gameCreationAlgorithm ?? 'two_stage_local',
        scheduledGameId: fill.selectedScheduledGame?.id ?? null,
        isAltered: false,
      }
    : {
        ...EMPTY_GAME_CREATION,
        algorithm: fill.gameCreationAlgorithm ?? 'two_stage_local',
      };

  const rosterFull = isFullRoster(team1, team2);
  const startActiveMatch = courtType === 'active' && rosterFull;
  const nextCourt = {
    team1,
    team2,
    inProgress: startActiveMatch,
    gameCreation: originMeta,
    matchmakingRelaxed: fill?.matchmakingRelaxed || false,
    matchmakingRelaxationDetails: fill?.matchmakingRelaxationDetails,
    matchmakingDebugInfo: fill?.matchmakingDebugInfo,
  };
  if (startActiveMatch) {
    markCourtMatchStarted(nextCourt);
  }

  if (courtType === 'active') {
    const courtAssignments = (state.courtAssignments || []).map((court) =>
      Number(court.courtNumber) === Number(index)
        ? { ...court, ...nextCourt, courtNumber: Number(index) }
        : court
    );
    return {
      ...state,
      courtAssignments,
      waitingList: (state.waitingList || []).filter((id) => !seated.has(id)),
    };
  }

  const nextAssignments = [...(state.nextAssignments || [])];
  while (nextAssignments.length <= index) {
    nextAssignments.push({
      courtNumber: nextAssignments.length,
      team1: [],
      team2: [],
      inProgress: false,
      gameCreation: { origin: null, algorithm: null, isAltered: false, scheduledGameId: null },
    });
  }
  nextAssignments[index] = {
    ...nextAssignments[index],
    ...nextCourt,
    courtNumber: index,
  };

  return {
    ...state,
    nextAssignments,
    waitingList: (state.waitingList || []).filter((id) => !seated.has(id)),
  };
}

export function buildSeatCommandFromFill(fill, {
  courtType,
  index,
  expectedVersion = -1,
  overwriteOwnRefill = false,
  causedByScoreEventId = null,
}) {
  const team1 = rosterIds(fill?.team1);
  const team2 = rosterIds(fill?.team2);
  return {
    type: 'seat',
    courtType,
    index,
    team1,
    team2,
    inProgress: courtType === 'active' && isFullRoster(team1, team2),
    gameCreation: {
      origin: fill?.type === 'scheduled' ? 'scheduled' : 'matchmaking',
      algorithm: fill?.gameCreationAlgorithm ?? 'two_stage_local',
      isAltered: false,
      scheduledGameId: fill?.selectedScheduledGame?.id ?? null,
    },
    expectedVersion,
    overwriteOwnRefill,
    causedByScoreEventId,
  };
}
